import { Descriptions, Row } from "antd";
import cpfMask from "../../../utils/getCpfMask";
import phoneMask from "../../../utils/getPhoneMask";
import getAtribute from "../../../utils/getAtribute";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";

export function DetailsUser({ entidade }) {
  const history = useHistory();

  if (!entidade) {
    return;
  }
  return (
    <>
      <Row justify="center" align="middle">
        <div className="ant-descriptions-title">
          {" "}
          <ArrowLeftOutlined onClick={() => history.goBack()} /> Dados do
          Solicitante
        </div>
      </Row>
      <br />

      <Descriptions>
        <Descriptions.Item label="Funcionário terceirizado?">
          <p>{entidade.tercerizado ? "Sim" : "Não"}</p>
        </Descriptions.Item>
        <Descriptions.Item label="Nome">
          <p>{getAtribute(entidade, "nome")}</p>
        </Descriptions.Item>
        <Descriptions.Item label="CPF">
          {cpfMask(getAtribute(entidade, "cpf"))}
        </Descriptions.Item>
        <Descriptions.Item label="Matrícula">
          {getAtribute(entidade, "matricula")}
        </Descriptions.Item>
        <Descriptions.Item label="RG">
          {getAtribute(entidade, "rg")}
        </Descriptions.Item>
        <Descriptions.Item label="UF RG">
          {getAtribute(entidade, "estadoRg")}
        </Descriptions.Item>
        <Descriptions.Item label="E-mail">
          {getAtribute(entidade, "emailInstitucional")}
        </Descriptions.Item>
        <Descriptions.Item label="Telefone">
          {phoneMask(getAtribute(entidade, "telefone"))}
        </Descriptions.Item>
        <Descriptions.Item label="Sexo">
          {getAtribute(entidade, "genero")}
        </Descriptions.Item>
        <Descriptions.Item label="Estado civil">
          {getAtribute(entidade, "estadoCivil")}
        </Descriptions.Item>
        <Descriptions.Item label="Mãe">
          {getAtribute(entidade, "nomeMae")}
        </Descriptions.Item>
        <Descriptions.Item label="Pai">
          {getAtribute(entidade, "nomePai")}
        </Descriptions.Item>
      </Descriptions>
      <div className="divider" />
    </>
  );
}
